// src/components/CustomerSummary/panels/SectionsPanel.jsx
// ============================================================================
// BLOCK CS.UI.4 — SectionsPanel
// ----------------------------------------------------------------------------
// PURPOSE
// - Renders ordered list of section cards.
// - Avoids inline JSX lambdas (react/jsx-no-bind) by passing unbound handlers.
// ============================================================================

import React from 'react';

import Stack from '@mui/material/Stack';

import SectionCard from '../components/SectionCard.jsx';
import SECTION_LABELS from '../Constants/sectionLabels.js';

export default function SectionsPanel({
  // data
  order = [],
  sections = {},
  locks = {},
  expanded = {},

  // actions (controller-owned)
  onToggleExpand = () => {},
  onToggleLock = () => {},
  onAuto = () => {},
  onClear = () => {},
  onMoveUp = () => {},
  onMoveDown = () => {},
  onChangeText = () => {},

  // UI prefs (shareable layout settings)
  uiPrefs,
  onChangeUiPrefs = () => {},
  onSetTableColumnWidths = () => {},
}) {
  const orderArray = Array.isArray(order) ? order : [];

  // -------------------------------------------------------------------------
  // BLOCK CS.UI.4.1 — Derived section UI gating
  // -------------------------------------------------------------------------
  const isDerived = React.useCallback(
    (k) =>
      k === 'studiesStartedWorkflowDistribution' || k === 'finalizedStudiesWorkflowDistributions',
    []
  );

  return (
    <Stack spacing={1.5}>
      {orderArray.map((key, index) => (
        <SectionCard
          key={key}
          sectionKey={key}
          title={SECTION_LABELS[key] || key}
          value={sections[key] || ''}
          locked={Boolean(locks[key])}
          expanded={Boolean(expanded[key])}
          canMoveUp={index > 0}
          canMoveDown={index < orderArray.length - 1}
          isDerived={isDerived(key)}
          onToggleExpand={onToggleExpand}
          onToggleLock={onToggleLock}
          onAuto={onAuto}
          onClear={onClear}
          onMoveUp={onMoveUp}
          onMoveDown={onMoveDown}
          onChangeText={onChangeText}
          uiPrefs={uiPrefs}
          onChangeUiPrefs={onChangeUiPrefs}
          onSetTableColumnWidths={onSetTableColumnWidths}
        />
      ))}
    </Stack>
  );
}
